<script lang="ts">
  import { pluralize } from '$lib/utils';

  import Button from '$components/mds/Buttons/Button/Button.svelte';
  import IconWrapper from '$components/mds/IconWrapper/IconWrapper.svelte';
  import { Image, ProgressiveImage } from '$mds/Image';
  import { faUsers, faComments } from '@fortawesome/pro-solid-svg-icons';

  export let group: any = {};
</script>

<div
  class=" bg-ondark-medium ease-spring-out relative grid h-full scale-100 cursor-pointer grid-rows-[min-content,1fr] overflow-hidden rounded-xl p-1 pb-0 shadow-md shadow-transparent transition-all duration-700 hover:scale-105 hover:shadow-black/20"
>
  <a href="/communities/{group?.slug}" class="absolute inset-0 z-10" title="View group">
    <span class="sr-only">View group</span>
  </a>
  <ProgressiveImage
    src={group?.cover}
    class="h-[104px] w-full rounded-t-lg object-cover object-center"
    alt={group?.title}
    sizes={{ xs: 420, sm: 500 }}
  />
  <div class="relative mt-4 grid grid-rows-[min-content,1fr] gap-5 p-4">
    <Image
      src={group?.logo}
      class="absolute -top-8 left-4 h-8 w-8 object-cover"
      sizes={{ xs: 32 }}
      rounded="rounded-full"
      fit="cover"
      alt="{group?.title} logo"
    />
    <div class="flex flex-col gap-2">
      <span class="text-body-lg text-ondark-primary highlight line-clamp-2">
        {@html group._formatted?.title ?? group.title ?? ''}
      </span>
      <span class="text-body-2xs highlight line-clamp-3">
        {@html group._formatted?.description ?? group.description ?? ''}
      </span>
    </div>
    <div class="text-body-2xs flex items-center justify-around self-end">
      <div class="flex flex-col items-center justify-between gap-1">
        <IconWrapper icon={faUsers} />
        <span>{pluralize('member', group.member_count)}</span>
      </div>
      <div class="bg-ondark-high h-8 w-px"></div>
      <div class="flex flex-col items-center justify-between gap-1">
        <IconWrapper icon={faComments} />
        <span>{pluralize('post', group.post_count)}</span>
      </div>
    </div>
  </div>
</div>
